/**
 * cssAlign — maps a PassDesign field's Apple `PKTextAlignment*` value to the
 * matching CSS `text-align` (UX4 item 3). `buildPassJsonFromDesign` already
 * emits `textAlignment` correctly (passDesignBuilder.ts) — neither PassCanvas
 * nor ApplePassPreview applied it visually before this. `PKTextAlignmentNatural`
 * and absent both mean "no explicit override": the caller's own default
 * alignment wins, mirroring what iOS itself does for Natural.
 */
import type { PassFieldAlignment } from '@insurwiz/wallet-core';

export function cssAlign(alignment?: PassFieldAlignment): 'left' | 'center' | 'right' | undefined {
  switch (alignment) {
    case 'PKTextAlignmentLeft':
      return 'left';
    case 'PKTextAlignmentCenter':
      return 'center';
    case 'PKTextAlignmentRight':
      return 'right';
    default:
      return undefined;
  }
}
